import React, { useState, useEffect } from "react";
import formatNumber from "../utils/formatNumber";
import {
  Box, Card, CardContent, Typography,
  Table, TableBody, TableCell, TableHead, TableRow,
  Avatar, IconButton, Pagination,
  TextField, InputAdornment, TableContainer,
  Tooltip, Dialog, DialogTitle, DialogContent,
  DialogActions, Button, List, ListItem,
  ListItemIcon, ListItemText, Chip,
  MenuItem, Select, FormControl, InputLabel,
  Snackbar, Alert, Tabs, Tab
} from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import no_user from "../assets/no_user.png";
import nodatafound from "../assets/nodatafound.png";
import "bootstrap-icons/font/bootstrap-icons.css";

import {
  Search as SearchIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Description as DescriptionIcon,
  WarningAmber,
  FilterList,
  DirectionsCar,
  TwoWheeler,
  LocalShipping,
  ContentCopy,
  Visibility,
  ArrowUpward,
  ArrowDownward,
  Refresh as RefreshIcon,
  AirportShuttle, CommuteOutlined, DescriptionOutlined,
  TrendingUp, Gavel, WbSunny, LocalFireDepartment,
  SwapHoriz, DirectionsBus
} from "@mui/icons-material";

import CustomerDetailsView from "./CustomerDetailsView";
import { red } from "@mui/material/colors";
export default function CustomerDetails({
  users,
  searchTerm,
  setSearchTerm,
  page,
  setPage,
  filteredUsers,
  handleEditUser,
  handleDeleteUser,
  searchColumn,
  setSearchColumn,
  statusFilter,
  setStatusFilter,
  getUserStatus,
  setActiveSection,
  handleOpenRegistration,
  loggedUserType,
  handleEnquirySearch,
  filteredEnqUsers,
  enquirySearchPhone,
  setEnquirySearchPhone,
  activeSection
}) {
  const [openFileDialog, setOpenFileDialog] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [] = useState(null);
  const [deleteUserId, setDeleteUserId] = useState(null);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
  const [viewDetailsDialog, setViewDetailsDialog] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [fileViewer, setFileViewer] = useState(null); // { url, name, type }
  const [activeTab, setActiveTab] = useState(0);

  // Enquiry Form State
  const [enquiryForm, setEnquiryForm] = useState({
    name: "",
    phone: "",
    vehicleNumber: ""
  });


  // Loading state for refresh
  const [isRefreshing, setIsRefreshing] = useState(false);

  // Sorting state
  const [sortOrder, setSortOrder] = useState("asc");
  const [vehicleTypeFilter, setVehicleTypeFilter] = useState("all");

  /* ✅ PASTE HERE */
  React.useEffect(() => {
    setPage(0);
  }, [sortOrder, searchTerm, statusFilter, searchColumn, vehicleTypeFilter]);

  React.useEffect(() => {
    if (enquirySearchPhone) {
      const searchParams = { name: "", phone: enquirySearchPhone, vehicleNumber: "" };
      setEnquiryForm(searchParams);
      handleEnquirySearch(searchParams);
      setEnquirySearchPhone(""); // Clear it so it doesn't re-trigger
    }
  }, [enquirySearchPhone, handleEnquirySearch, setEnquirySearchPhone]);


  // Reset form when section changes or on mount
  useEffect(() => {
    setEnquiryForm({ name: "", phone: "", vehicleNumber: "" });
  }, [activeSection]);
 
  const handleOpenFiles = (files) => {
    setSelectedFiles(files || []);
    setOpenFileDialog(true);
  };

  const handleCloseFiles = () => {
    setSelectedFiles([]);
    setOpenFileDialog(false);
  };

  const handlePreview = (file) => {
    if (!file || !file.url) return;
    setFileViewer({ url: file.url, name: file.name, type: file.type });
  };

  const handleCloseFileViewer = () => setFileViewer(null);

  const handleDownloadFile = () => {
    if (!fileViewer) return;
    const a = document.createElement("a");
    a.href = fileViewer.url;
    a.download = fileViewer.name || "download";
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const handleOpenDelete = (id) => {
    setDeleteUserId(id);
    setOpenDeleteDialog(true);
  };

  const handleCloseDelete = () => {
    setDeleteUserId(null);
    setOpenDeleteDialog(false);
  };

  // Toggle sort order function
  const toggleSortOrder = () => {
    setSortOrder(prev => prev === "asc" ? "desc" : "asc");
  };

  // Refresh data function
  const handleRefresh = () => {
    setIsRefreshing(true);

    setTimeout(() => {
      setSnackbar({
        open: true,
        message: "Data refreshed successfully!",
        severity: "success"
      });
      setIsRefreshing(false);

      // Reset search and filters
      setSearchTerm("");
      setPage(0);
      setSearchColumn("all");
      setStatusFilter("all");
      setVehicleTypeFilter("all");
    }, 1000);
  };

  const getStatusColor = (endDate) => {
    if (!endDate) return "default";

    const end = new Date(endDate);
    const today = new Date();
    const diffTime = end - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays < 0) return "error";
    if (diffDays <= 15) return "warning";
    return "success";
  };

  const getStatusText = (endDate) => {
    if (!endDate) return "No Date";
    const end = new Date(endDate);
    const today = new Date();
    const diffTime = end - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays < 0) return "Expired";
    if (diffDays <= 15) return "Expiring Soon";
    return "Active";
  };

  const getUserAggregateStatus = (user) => {
    const vehicles = user.vehicles || [];
    const dates = vehicles.map(v => v.endDate).filter(d => !!d);
    if (user.endDate) dates.push(user.endDate);

    if (dates.length === 0) return "Active"; // Default to active if no dates

    const statuses = dates.map(d => getStatusText(d));
    if (statuses.includes("Expired")) return "Expired";
    if (statuses.includes("Expiring Soon")) return "Expiring Soon";
    return "Active";
  };

  const getUserAggregateColor = (user) => {
    const status = getUserAggregateStatus(user);
    if (status === "Expired") return "error";
    if (status === "Expiring Soon") return "warning";
    return "success";
  };

  const formatDate = (dateString) => {
    if (!dateString) return "Not Set";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    } catch (error) {
      return "Invalid Date";
    }
  };

  const getFilteredUsersForDisplay = () => {
    return filteredUsers.filter(user => {
      const matchStatus = statusFilter === "all" || getUserAggregateStatus(user).toLowerCase() === statusFilter.toLowerCase();
      const matchVehicle = vehicleTypeFilter === "all" || (user.vehicles && user.vehicles.some(v => (v.type || "two_wheeler").toLowerCase() === vehicleTypeFilter.toLowerCase()));
      return matchStatus && matchVehicle;
    });
  };


  // ✅ TRUE alphabetical order (case-insensitive)
  const sortedUsers = [...getFilteredUsersForDisplay()].sort((a, b) => {
    const nameA = (a.name || "").trim();
    const nameB = (b.name || "").trim();

    return sortOrder === "asc"
      ? nameA.localeCompare(nameB, undefined, { sensitivity: "base" })
      : nameB.localeCompare(nameA, undefined, { sensitivity: "base" });
  });

  // Only show 5 rows per page
  const displayedUsers = sortedUsers.slice(page * 5, (page + 1) * 5);
  const displayedEnqUsers = filteredEnqUsers.slice(page * 5, (page + 1) * 5);


  const copyToClipboard = (text) => {
    if (!text) return;
    navigator.clipboard.writeText(text).then(() => {
      setSnackbar({
        open: true,
        message: "Email copied to clipboard!",
        severity: "success"
      });
    });
  };

  const getVehicleIcon = (type) => {
    switch ((type || "two_wheeler")?.toLowerCase()) {
      case "two_wheeler": return <TwoWheeler fontSize="small" />;
      case "private_car": return <DirectionsCar fontSize="small" />;
      case "passengers_vehicle": return <AirportShuttle fontSize="small" />;
      case "goods_vehicle": return <LocalShipping fontSize="small" />;
      case "miscellaneous_vehicle": return <CommuteOutlined fontSize="small" />;
      case "non_motor": return <DescriptionOutlined fontSize="small" />;
      case "idv_increase": return <TrendingUp fontSize="small" />;
      case "hp_endorsement": return <Gavel fontSize="small" />;
      case "solar_policy": return <WbSunny fontSize="small" />;
      case "fire_policy": return <LocalFireDepartment fontSize="small" />;
      case "name_transfer": return <SwapHoriz fontSize="small" />;
      case "school_bus": return <DirectionsBus fontSize="small" />;
      default: return <DirectionsCar fontSize="small" />;
    }
  };

  const handleViewDetails = (user) => {
    setSelectedUser(user);
    setViewDetailsDialog(true);
  };

  const getVehicleCountByType = (vehicles, type) => {
    if (!vehicles) return 0;
    return vehicles.filter(v => v.type?.toLowerCase() === type.toLowerCase()).length;
  };
  const handleEnquirySearchWhenClick = (ind) => {
    ind ? handleEnquirySearch(enquiryForm) : handleEnquirySearch(enquiryForm)
  }

  return (
    <Box sx={{ flexGrow: 1, p: { xs: 2, md: 3 }, pt: 0, fontFamily: "'Outfit', sans-serif", backgroundColor: "#0a0a0a", minHeight: "100vh" }}>
      <Box sx={{ mb: 2 }}>
        {loggedUserType !== "MARKETER" && (
          <Typography
            onClick={handleOpenRegistration}
            sx={{
              display: "inline-flex",
              alignItems: "center",
              cursor: "pointer",
              fontFamily: "'Poppins', sans-serif",
              color: "#ffffff",
              fontWeight: 500,
              "&:hover": { color: "#FDB813", textDecoration: "underline" }
            }}
          >
            <ArrowBackIcon sx={{ mr: 1, fontSize: "1.2rem", color: "#ffffff" }} />
            Back
          </Typography>
        )}
        {/* {activeTab === 1 && (
          <Typography align="center" variant="h5" color="#ffffff" sx={{ fontFamily: "'Outfit', sans-serif", fontWeight: 800, position: "absolute", top: "14vh", width: "100%", textAlign: "center" }}>
            Customer Enquiry Search
          </Typography>
        )} */}
      </Box>


      {/* HORIZONTAL MENU */}
      <Box sx={{ borderBottom: 1, borderColor: "rgba(255, 255, 255, 0.1)", mb: 3 }}>
        <Tabs
          value={activeTab}
          onChange={(e, v) => setActiveTab(v)}
          TabIndicatorProps={{ style: { backgroundColor: "#FDB813" } }}
          sx={{
            "& .MuiTab-root": {
              color: "rgba(255, 255, 255, 0.5)",
              fontFamily: "'Poppins', sans-serif",
              fontWeight: 600,
              textTransform: "none",
              fontSize: "1rem"
            },
            "& .Mui-selected": {
              color: "#FDB813 !important"
            }
          }}
        >
          {/* <Tab label="Customer Details" /> */}
          <Tab label="Customer Enquiry" />
        </Tabs>
      </Box>

      {/* TAB 0: CUSTOMER DETAILS */}
      <Box sx={{ display: activeTab === 10 ? "block" : "none" }}>
        <Card sx={{ borderRadius: { xs: 2, md: 3 }, background: "#111111", border: "1px solid rgba(253, 184, 19, 0.1)", boxShadow: "0 20px 60px rgba(0,0,0,0.6)" }}>
          <CardContent sx={{ p: { xs: 2, md: 3 } }}>
            <Box sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 3,
              flexWrap: "wrap",
              gap: 2
            }}>
              <Typography variant="h5" color="#ffffff" fontWeight={800} sx={{ fontFamily: "'Outfit', sans-serif", fontSize: { xs: "1.25rem", md: "1.5rem" } }}>
                Customer Details
              </Typography>

              <Box sx={{ display: "flex", gap: 1.5, alignItems: "center", flexWrap: "wrap", width: { xs: "100%", sm: "auto" } }}>
                {/* Refresh Button */}
                <Tooltip title="Refresh Data">
                  <IconButton
                    onClick={handleRefresh}
                    disabled={isRefreshing}
                    sx={{
                      border: "1px solid rgba(255, 255, 255, 0.4)",
                      color: "#ffffff",
                      fontFamily: "'Poppins', sans-serif",
                      "&:hover": {
                        backgroundColor: "rgba(255, 255, 255, 0.1)",
                        borderColor: "#ffffff"
                      }
                    }}
                  >
                    <RefreshIcon
                      sx={{
                        color: "#ffffff",
                        animation: isRefreshing ? "spin 1s linear infinite" : "none",
                        "@keyframes spin": {
                          "0%": { transform: "rotate(0deg)" },
                          "100%": { transform: "rotate(360deg)" }
                        }
                      }}
                    />
                  </IconButton>
                </Tooltip>

                {/* Sort Order Button */}
                <Tooltip title={`Sort ${sortOrder === "asc" ? "A→Z" : "Z→A"}`}>
                  <IconButton
                    onClick={toggleSortOrder}
                    sx={{
                      border: "1px solid",
                      borderColor: "#FDB813",
                      color: "#FDB813",
                      fontFamily: "'Outfit', sans-serif",
                      "&:hover": {
                        backgroundColor: "#FDB813",
                        color: "#111111"
                      }
                    }}
                  >
                    {sortOrder === "asc" ? <ArrowUpward /> : <ArrowDownward />}
                  </IconButton>
                </Tooltip>

                <FormControl size="small" sx={{ minWidth: { xs: "100%", sm: 120 }, flex: { xs: 1, sm: "initial" } }}>
                  <InputLabel sx={{ fontFamily: "'Poppins', sans-serif" }}>Search In</InputLabel>
                  <Select
                    value={searchColumn}
                    label="Search In"
                    onChange={(e) => setSearchColumn(e.target.value)}
                    sx={{ fontFamily: "'Poppins', sans-serif" }}
                  >
                    <MenuItem value="all" sx={{ fontFamily: "'Poppins', sans-serif" }}>All Columns</MenuItem>
                    <MenuItem value="name" sx={{ fontFamily: "'Poppins', sans-serif" }}>Name</MenuItem>
                    <MenuItem value="phone" sx={{ fontFamily: "'Poppins', sans-serif" }}>Phone</MenuItem>
                    <MenuItem value="location" sx={{ fontFamily: "'Poppins', sans-serif" }}>Location</MenuItem>
                    <MenuItem value="email" sx={{ fontFamily: "'Poppins', sans-serif" }}>Email</MenuItem>
                    {loggedUserType === "ADMIN" && (
                      <MenuItem value="createdBy" sx={{ fontFamily: "'Poppins', sans-serif" }}>Created By</MenuItem>
                    )}
                    <MenuItem value="vehicleNumber" sx={{ fontFamily: "'Poppins', sans-serif" }}>Vehicle Number</MenuItem>
                  </Select>
                </FormControl>

                <FormControl size="small" sx={{ minWidth: { xs: "100%", sm: 140 }, flex: { xs: 1, sm: "initial" } }}>
                  <InputLabel sx={{ fontFamily: "'Poppins', sans-serif" }}>Status</InputLabel>
                  <Select
                    value={statusFilter}
                    label="Status"
                    onChange={(e) => setStatusFilter(e.target.value)}
                    startAdornment={<FilterList fontSize="small" sx={{ mr: 1 }} />}
                    sx={{ fontFamily: "'Poppins', sans-serif" }}
                  >
                    <MenuItem value="all" sx={{ fontFamily: "'Poppins', sans-serif" }}>All Status</MenuItem>
                    <MenuItem value="active" sx={{ fontFamily: "'Poppins', sans-serif" }}>Active</MenuItem>
                    <MenuItem value="expiring soon" sx={{ fontFamily: "'Poppins', sans-serif" }}>Expiring Soon</MenuItem>
                    <MenuItem value="expired" sx={{ fontFamily: "'Poppins', sans-serif" }}>Expired</MenuItem>
                    <MenuItem value="no date" sx={{ fontFamily: "'Poppins', sans-serif" }}>No Date</MenuItem>
                  </Select>
                </FormControl>

                <FormControl size="small" sx={{ minWidth: { xs: "100%", sm: 140 }, flex: { xs: 1, sm: "initial" } }}>
                  <InputLabel sx={{ fontFamily: "'Poppins', sans-serif" }}>Vehicle Type</InputLabel>
                  <Select
                    value={vehicleTypeFilter}
                    label="Vehicle Type"
                    onChange={(e) => setVehicleTypeFilter(e.target.value)}
                    startAdornment={<FilterList fontSize="small" sx={{ mr: 1 }} />}
                    sx={{ fontFamily: "'Poppins', sans-serif" }}
                  >
                    <MenuItem value="all" sx={{ fontFamily: "'Poppins', sans-serif" }}>All Vehicles</MenuItem>
                    <MenuItem value="two_wheeler" sx={{ fontFamily: "'Poppins', sans-serif" }}>Two Wheeler</MenuItem>
                    <MenuItem value="private_car" sx={{ fontFamily: "'Poppins', sans-serif" }}>Private Car</MenuItem>
                    <MenuItem value="passengers_vehicle" sx={{ fontFamily: "'Poppins', sans-serif" }}>Passengers Vehicle</MenuItem>
                    <MenuItem value="goods_vehicle" sx={{ fontFamily: "'Poppins', sans-serif" }}>Goods Vehicle</MenuItem>
                    <MenuItem value="miscellaneous_vehicle" sx={{ fontFamily: "'Poppins', sans-serif" }}>Miscellaneous Vehicle</MenuItem>
                    <MenuItem value="non_motor" sx={{ fontFamily: "'Poppins', sans-serif" }}>Non - Motor</MenuItem>
                    <MenuItem value="idv_increase" sx={{ fontFamily: "'Poppins', sans-serif" }}>IDV Increase</MenuItem>
                    <MenuItem value="hp_endorsement" sx={{ fontFamily: "'Poppins', sans-serif" }}>HP ENDORSEMENT</MenuItem>
                    <MenuItem value="solar_policy" sx={{ fontFamily: "'Poppins', sans-serif" }}>SOLAR POLICY</MenuItem>
                    <MenuItem value="fire_policy" sx={{ fontFamily: "'Poppins', sans-serif" }}>Fire Policy</MenuItem>
                    <MenuItem value="name_transfer" sx={{ fontFamily: "'Poppins', sans-serif" }}>Name Transfer</MenuItem>
                    <MenuItem value="school_bus" sx={{ fontFamily: "'Poppins', sans-serif" }}>SCHOOL BUS</MenuItem>
                  </Select>
                </FormControl>

                <TextField
                  size="small"
                  placeholder={`Search in ${searchColumn === "all" ? "all columns" : searchColumn}...`}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  sx={{
                    minWidth: { xs: "100%", md: 250 },
                    flex: { xs: "1 1 100%", md: "initial" },
                    "& .MuiOutlinedInput-root": {
                      fontFamily: "'Outfit', sans-serif",
                      color: "#ffffff",
                      "& fieldset": { borderColor: "rgba(255, 255, 255, 0.1)" },
                      "&:hover fieldset": { borderColor: "#FDB813" }
                    },
                    "& .MuiInputLabel-root": {
                      fontFamily: "'Outfit', sans-serif",
                      color: "rgba(255, 255, 255, 0.6)"
                    }
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    )
                  }}
                />
              </Box>
            </Box>

            <Box sx={{
              display: "flex",
              gap: { xs: 1, sm: 2 },
              mb: 3,
              flexWrap: "wrap",
              justifyContent: { xs: "flex-start", sm: "center" }
            }}>
              <Chip
                label={`Total: ${formatNumber(users.length)}`}
                variant="outlined"
                size="small"
                sx={{
                  fontFamily: "'Poppins', sans-serif",
                  color: "#ffffff",
                  borderColor: "rgba(255, 255, 255, 0.5)",
                  fontWeight: 600
                }}
              />
              <Chip
                label={`Active: ${formatNumber(users.filter(u => getUserAggregateStatus(u) === "Active").length)}`}
                color="success"
                variant="outlined"
                size="small"
                sx={{ fontFamily: "'Poppins', sans-serif" }}
              />
              <Chip
                label={`Expiring: ${formatNumber(users.filter(u => getUserAggregateStatus(u) === "Expiring Soon").length)}`}
                color="warning"
                variant="outlined"
                size="small"
                sx={{ fontFamily: "'Poppins', sans-serif" }}
              />
              <Chip
                label={`Expired: ${formatNumber(users.filter(u => getUserAggregateStatus(u) === "Expired").length)}`}
                color="error"
                variant="outlined"
                size="small"
                sx={{ fontFamily: "'Poppins', sans-serif" }}
              />
              <Chip
                icon={<TwoWheeler />}
                label={`Two Wheeler: ${formatNumber(users.reduce((acc, u) => acc + getVehicleCountByType(u.vehicles, 'two_wheeler'), 0))}`}
                variant="outlined"
                size="small"
                sx={{ fontFamily: "'Poppins', sans-serif" }}
              />
              <Chip
                icon={<DirectionsCar />}
                label={`Private Car: ${formatNumber(users.reduce((acc, u) => acc + getVehicleCountByType(u.vehicles, 'private_car'), 0))}`}
                variant="outlined"
                size="small"
                sx={{ fontFamily: "'Poppins', sans-serif" }}
              />
              <Chip
                icon={<LocalShipping />}
                label={`Goods Vehicle: ${formatNumber(users.reduce((acc, u) => acc + getVehicleCountByType(u.vehicles, 'goods_vehicle'), 0))}`}
                variant="outlined"
                size="small"
                sx={{ fontFamily: "'Poppins', sans-serif" }}
              />
            </Box>

            <TableContainer sx={{ overflowX: "auto", maxWidth: "100%" }}>
              <Table size="small">
                <TableHead>
                  <TableRow sx={{ backgroundColor: "action.hover" }}>
                    {[ "S.No", "Name", "Phone", "Location", "Email", "Created By", "Vehicle", "Schedule Date", "End Date", "Remarks", "Status", "Files", "Actions" ]
                      .filter(h => h !== "Created By" || loggedUserType === "ADMIN")
                      .map(h => (
                        <TableCell
                          key={h}
                          sx={{
                            fontWeight: 800,
                            color: "#ffffff",
                            whiteSpace: "nowrap",
                            fontFamily: "'Outfit', sans-serif",
                            px: 2,
                            py: 1.5,
                            borderBottom: "1px solid rgba(253, 184, 19, 0.1)"
                          }}
                        >
                          {h}
                        </TableCell>
                      ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {displayedUsers.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={10} style={{ textAlign: "center", padding: "40px" }}>
                        <img
                          src={no_user}
                          alt="No users illustration"
                          style={{ maxWidth: "500px", height: "auto", borderRadius: "100px" }}
                        />
                      </TableCell>
                    </TableRow>
                  ) : (
                    displayedUsers.map((u, i) => (
                      <TableRow
                        key={u.id || i}
                        hover
                        sx={{
                          transition: "all 0.3s ease",
                          '&:hover': {
                            backgroundColor: 'rgba(253, 184, 19, 0.03) !important',
                            boxShadow: 'inset 4px 0 0 #FDB813, 0 4px 15px rgba(0,0,0,0.2)',
                            transform: 'scale(1.002)'
                          }
                        }}
                      >
                        <TableCell sx={{ fontFamily: "'Poppins', sans-serif" }}>
                          {sortOrder === "asc" ? i + 1 + page * 5 : sortedUsers.length - (i + page * 5)}
                        </TableCell>
                        <TableCell>
                          <Box sx={{ display: "flex", gap: 1.5, alignItems: "center" }}>
                            <Avatar sx={{ bgcolor: "#667eea", width: 36, height: 36 }}>
                              {(u.name || "?").charAt(0).toUpperCase()}
                            </Avatar>
                            <Box>
                              <Typography variant="body2" fontWeight={500} sx={{ fontFamily: "'Poppins', sans-serif" }}>
                                {u.name || "--"}
                              </Typography>
                            </Box>
                          </Box>
                        </TableCell>
                        <TableCell sx={{ fontFamily: "'Poppins', sans-serif" }}>{u.phone || "--"}</TableCell>
                        <TableCell sx={{ fontFamily: "'Poppins', sans-serif" }}>{u.location || "--"}</TableCell>
                        <TableCell>
                          {u.email ? (
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                              <Tooltip title="Copy email">
                                <IconButton
                                  size="small"
                                  onClick={() => copyToClipboard(u.email)}
                                  sx={{
                                    color: "#ffffff",
                                    fontFamily: "'Poppins', sans-serif",
                                    opacity: 0.7,
                                    "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.1)", opacity: 1 }
                                  }}
                                >
                                  <ContentCopy fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            </Box>
                          ) : (
                            <Typography sx={{ fontFamily: "'Poppins', sans-serif" }}>--</Typography>
                          )}
                        </TableCell>
                        {loggedUserType === "ADMIN" && (
                          <TableCell>
                            <Typography variant="body2" sx={{ fontFamily: "'Poppins', sans-serif", fontWeight: 500 }}>
                              {u.createdBy || "--"}
                            </Typography>
                          </TableCell>
                        )}
                        <TableCell>
                          {u.vehicles?.filter(v => v.number?.trim()).length > 0 ? (
                            <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                              {u.vehicles
                                .filter(v => v.number?.trim())
                                .slice(0, 1)
                                .map((vehicle, idx) => (
                                  <Box key={idx} sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                                    {getVehicleIcon(vehicle.type)}
                                    <Typography variant="body2" component="span" fontWeight={500} sx={{ fontFamily: "'Poppins', sans-serif" }}>
                                      {vehicle.number}
                                    </Typography>
                                  </Box>
                                ))}
                              {u.vehicles.filter(v => v.number?.trim()).length > 1 && (
                                <Typography variant="caption" color="text.secondary" sx={{ fontFamily: "'Poppins', sans-serif" }}>
                                  +{u.vehicles.filter(v => v.number?.trim()).length - 1} more
                                </Typography>
                              )}
                            </Box>
                          ) : (
                            <Typography color="text.secondary" sx={{ fontFamily: "'Poppins', sans-serif" }}>--</Typography>
                          )}
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" sx={{ fontFamily: "'Poppins', sans-serif" }}>
                            {formatDate(u.scheduleDate || (u.vehicles && u.vehicles[0]?.scheduleDate))}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" sx={{ fontFamily: "'Poppins', sans-serif" }}>
                            {formatDate(u.endDate || (u.vehicles && u.vehicles[0]?.endDate))}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" sx={{ fontFamily: "'Poppins', sans-serif", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                            {u.remarks || "--"}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Chip
                            label={getUserAggregateStatus(u)}
                            color={getUserAggregateColor(u)}
                            size="small"
                            sx={{ fontWeight: 600, minWidth: 100, fontFamily: "'Poppins', sans-serif" }}
                          />
                        </TableCell>
                        <TableCell>
                          {u.documents?.length > 0 ? (
                            <Tooltip title={`${u.documents.length} file(s)`}>
                              <Chip
                                icon={<DescriptionIcon sx={{ color: "white !important" }} fontSize="small" />}
                                label={`${u.documents.length} File(s)`}
                                variant="outlined"
                                sx={{
                                  fontFamily: "'Poppins', sans-serif",
                                  color: "white",
                                  borderColor: "rgba(255, 255, 255, 0.4)",
                                  backgroundColor: "rgba(255, 255, 255, 0.05)",
                                  "&:hover": {
                                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                                    borderColor: "white"
                                  },
                                  cursor: "pointer",
                                  "& .MuiChip-icon": { color: "white" }
                                }}
                                onClick={() => handleOpenFiles(u.documents)}
                              />
                            </Tooltip>
                          ) : (
                            <Chip
                              label="No Files"
                              size="small"
                              variant="outlined"
                              sx={{ fontFamily: "'Poppins', sans-serif", color: "rgba(255, 255, 255, 0.5)", borderColor: "rgba(255, 255, 255, 0.2)" }}
                            />
                          )}
                        </TableCell>
                        <TableCell>
                          <Box sx={{ display: "flex", gap: 1 }}>
                            <Tooltip title="View Details">
                              <IconButton
                                size="small"
                                onClick={() => handleViewDetails(u)}
                                sx={{ color: "#ffffff", opacity: 0.8, "&:hover": { opacity: 1, backgroundColor: "rgba(255, 255, 255, 0.1)" } }}
                              >
                                <Visibility fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Edit User">
                              <IconButton
                                size="small"
                                onClick={() => handleEditUser(u)}
                                sx={{ color: "#ffffff", opacity: 0.8, "&:hover": { opacity: 1, backgroundColor: "rgba(255, 255, 255, 0.1)" } }}
                              >
                                <EditIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Delete User">
                              <IconButton
                                size="small"
                                onClick={() => handleOpenDelete(u.id)}
                                sx={{ color: "#ff4d4d", opacity: 0.8, "&:hover": { opacity: 1, backgroundColor: "rgba(255, 77, 77, 0.1)" } }}
                              >
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 3 }}>
              <Typography variant="body2" color="text.secondary" sx={{ fontFamily: "'Poppins', sans-serif" }}>
                Showing {displayedUsers.length} of {sortedUsers.length} users • Page {page + 1} of {Math.ceil(sortedUsers.length / 5)}
              </Typography>
              <Pagination
                page={page + 1}
                count={Math.ceil(sortedUsers.length / 5)}
                onChange={(e, v) => setPage(v - 1)}
                sx={{
                  "& .MuiPaginationItem-root": { color: "#ffffff", borderColor: "rgba(255,255,255,0.2)" },
                  "& .Mui-selected": { bgcolor: "#FDB813 !important", color: "#111111", fontWeight: 800 }
                }}
                showFirstButton
                showLastButton
              />
            </Box>

          </CardContent>
        </Card>
      </Box>

      {/* TAB 1: CUSTOMER ENQUIRY */}
      <Box sx={{ display: activeTab === 0 ? "block" : "none" }}>
        <Card sx={{ borderRadius: { xs: 2, md: 3 }, background: "#111111", border: "1px solid rgba(253, 184, 19, 0.1)", boxShadow: "0 20px 60px rgba(0,0,0,0.6)", minHeight: "60vh" }}>
          <CardContent sx={{ p: { xs: 2, md: 3 } }}>
            <Box sx={{ mb: 4, display: "flex", alignItems: "center", gap: 1.5 }}>
              <SearchIcon sx={{ color: "#FDB813", fontSize: "2rem" }} />
              <Typography variant="h5" color="#ffffff" sx={{ fontFamily: "'Outfit', sans-serif", fontWeight: 800 }}>
                Customer Enquiry
              </Typography>
            </Box>

            <Box sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              gap: { xs: 2, md: 3 },
              alignItems: "center",
              justifyContent: "center",
              maxWidth: "1000px",
              mx: "auto",
              mb: 4
            }}>
              <TextField
                fullWidth
                label="Name"
                variant="outlined"
                value={enquiryForm.name}
                disabled={Boolean(enquiryForm.phone || enquiryForm.vehicleNumber)}
                onChange={(e) => setEnquiryForm({ ...enquiryForm, name: e.target.value })}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    fontFamily: "'Poppins', sans-serif",
                    color: "#ffffff",
                    "& fieldset": { borderColor: "rgba(255, 255, 255, 0.2)" },
                    "&:hover fieldset": { borderColor: "#FDB813" },
                    "&.Mui-focused fieldset": { borderColor: "#FDB813" },
                    "&.Mui-disabled": { color: "rgba(255, 255, 255, 0.3)" }
                  },
                  "& .MuiInputLabel-root": { color: "rgba(255, 255, 255, 0.6)", fontFamily: "'Poppins', sans-serif" },
                  "& .MuiInputLabel-root.Mui-focused": { color: "#FDB813" },
                  "& .MuiInputLabel-root.Mui-disabled": { color: "rgba(255, 255, 255, 0.3)" }
                }}
              />
              <TextField
                fullWidth
                label="Phone"
                variant="outlined"
                value={enquiryForm.phone}
                disabled={Boolean(enquiryForm.name || enquiryForm.vehicleNumber)}
                onChange={(e) => setEnquiryForm({ ...enquiryForm, phone: e.target.value })}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    fontFamily: "'Poppins', sans-serif",
                    color: "#ffffff",
                    "& fieldset": { borderColor: "rgba(255, 255, 255, 0.2)" },
                    "&:hover fieldset": { borderColor: "#FDB813" },
                    "&.Mui-focused fieldset": { borderColor: "#FDB813" },
                    "&.Mui-disabled": { color: "rgba(255, 255, 255, 0.3)" }
                  },
                  "& .MuiInputLabel-root": { color: "rgba(255, 255, 255, 0.6)", fontFamily: "'Poppins', sans-serif" },
                  "& .MuiInputLabel-root.Mui-focused": { color: "#FDB813" },
                  "& .MuiInputLabel-root.Mui-disabled": { color: "rgba(255, 255, 255, 0.3)" }
                }}
              />
              <TextField
                fullWidth
                label="Vehicle Number"
                variant="outlined"
                value={enquiryForm.vehicleNumber}
                disabled={Boolean(enquiryForm.name || enquiryForm.phone)}
                onChange={(e) => setEnquiryForm({ ...enquiryForm, vehicleNumber: e.target.value.replace(/\s/g, '').toUpperCase() })}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    fontFamily: "'Poppins', sans-serif",
                    color: "#ffffff",
                    "& fieldset": { borderColor: "rgba(255, 255, 255, 0.2)" },
                    "&:hover fieldset": { borderColor: "#FDB813" },
                    "&.Mui-focused fieldset": { borderColor: "#FDB813" },
                    "&.Mui-disabled": { color: "rgba(255, 255, 255, 0.3)" }
                  },
                  "& .MuiInputLabel-root": { color: "rgba(255, 255, 255, 0.6)", fontFamily: "'Poppins', sans-serif" },
                  "& .MuiInputLabel-root.Mui-focused": { color: "#FDB813" },
                  "& .MuiInputLabel-root.Mui-disabled": { color: "rgba(255, 255, 255, 0.3)" }
                }}
              />
              <Box sx={{ display: 'flex', gap: 2, width: { xs: "100%", md: "auto" }, flexDirection: "row", justifyContent: { xs: "center", sm: "flex-start" } }}>
                <Button
                  onClick={() => {
                    setEnquiryForm({ name: "", phone: "", vehicleNumber: "" });
                  }}
                  sx={{
                    fontFamily: "'Poppins', sans-serif",
                    color: "#ffffff",
                    fontWeight: 700,
                    width: 45,
                    height: 45,
                    minWidth: 45,
                    px: 4,
                    py: 1.5,
                    fontSize: "2rem",
                    "&:hover": {
                      color: "red"
                    }
                  }}
                >
                  <i class="bi bi-stars"></i>
                </Button>
                <Button
                  variant="contained"
                  onClick={() => handleEnquirySearchWhenClick(true)}
                  disabled={!enquiryForm.name && !enquiryForm.phone && !enquiryForm.vehicleNumber}
                  sx={{
                    fontFamily: "'Poppins', sans-serif",
                    background: "linear-gradient(135deg, #FDB813 0%, #f5a623 100%)",
                    color: "#111111",
                    fontWeight: 700,
                    width: 45,
                    height: 45,
                    minWidth: 45,   // prevents MUI button stretching
                    fontSize: "1rem",
                    borderRadius: "50%",
                    "&:hover": {
                      background: "linear-gradient(135deg, #f5a623 0%, #e09400 100%)",
                      boxShadow: "0 4px 16px rgba(253,184,19,0.4)"
                    },
                    "&.Mui-disabled": {
                      background: "rgba(255, 255, 255, 0.1)",
                      color: "rgba(255, 255, 255, 0.3)"
                    }
                  }}
                >
                  <i class="bi bi-search"></i>
                </Button>
              </Box>
            </Box>

            {/*enquiry table start*/}
            <TableContainer sx={{ overflowX: "auto", maxWidth: "100%" }}>
              <Table size="small">
                <TableHead>
                  <TableRow sx={{ backgroundColor: "action.hover" }}>
                    {["S.No", "Name", "Phone", "Location", "Email", "Created By", "Vehicle", "Schedule Date", "End Date", "Remarks", "Status", "Files", "Actions"]
                      .filter(h => h !== "Created By" || loggedUserType === "ADMIN")
                      .map(h => (
                        <TableCell
                          key={h}
                          sx={{
                            fontWeight: 800,
                            color: "#ffffff",
                            whiteSpace: "nowrap",
                            fontFamily: "'Outfit', sans-serif",
                            px: 2,
                            py: 1.5,
                            borderBottom: "1px solid rgba(253, 184, 19, 0.1)"
                          }}
                        >
                          {h}
                        </TableCell>
                      ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {displayedEnqUsers.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={10} style={{ textAlign: "center", padding: "40px" }}>
                        <img
                          src={nodatafound}
                          alt="No users illustration"
                          style={{ maxWidth: "300px", height: "auto", borderRadius: "70px" }}
                        />
                      </TableCell>
                    </TableRow>
                  ) : (
                    displayedEnqUsers.map((u, i) => (
                      <TableRow
                        key={u.id || i}
                        hover
                        sx={{
                          transition: "all 0.3s ease",
                          '&:hover': {
                            backgroundColor: 'rgba(253, 184, 19, 0.03) !important',
                            boxShadow: 'inset 4px 0 0 #FDB813, 0 4px 15px rgba(0,0,0,0.2)',
                            transform: 'scale(1.002)'
                          }
                        }}
                      >
                        <TableCell sx={{ fontFamily: "'Poppins', sans-serif" }}>
                          {sortOrder === "asc" ? i + 1 + page * 5 : sortedUsers.length - (i + page * 5)}
                        </TableCell>
                        <TableCell>
                          <Box sx={{ display: "flex", gap: 1.5, alignItems: "center" }}>
                            <Avatar sx={{ bgcolor: "#667eea", width: 36, height: 36 }}>
                              {(u.name || "?").charAt(0).toUpperCase()}
                            </Avatar>
                            <Box>
                              <Typography variant="body2" fontWeight={500} sx={{ fontFamily: "'Poppins', sans-serif" }}>
                                {u.name || "--"}
                              </Typography>
                            </Box>
                          </Box>
                        </TableCell>
                        <TableCell sx={{ fontFamily: "'Poppins', sans-serif" }}>{u.phone || "--"}</TableCell>
                        <TableCell sx={{ fontFamily: "'Poppins', sans-serif" }}>{u.location || "--"}</TableCell>
                        <TableCell>
                          {u.email ? (
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                              <Tooltip title="Copy email">
                                <IconButton
                                  size="small"
                                  onClick={() => copyToClipboard(u.email)}
                                  sx={{
                                    color: "#ffffff",
                                    fontFamily: "'Poppins', sans-serif",
                                    opacity: 0.7,
                                    "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.1)", opacity: 1 }
                                  }}
                                >
                                  <ContentCopy fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            </Box>
                          ) : (
                            <Typography sx={{ fontFamily: "'Poppins', sans-serif" }}>--</Typography>
                          )}
                        </TableCell>
                        {loggedUserType === "ADMIN" && (
                          <TableCell>
                            <Typography variant="body2" sx={{ fontFamily: "'Poppins', sans-serif", fontWeight: 500 }}>
                              {u.createdBy || "--"}
                            </Typography>
                          </TableCell>
                        )}
                        <TableCell>
                          {u.vehicles?.filter(v => v.number?.trim()).length > 0 ? (
                            <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                              {u.vehicles
                                .filter(v => v.number?.trim())
                                .slice(0, 1)
                                .map((vehicle, idx) => (
                                  <Box key={idx} sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                                    {getVehicleIcon(vehicle.type)}
                                    <Typography variant="body2" component="span" fontWeight={500} sx={{ fontFamily: "'Poppins', sans-serif" }}>
                                      {vehicle.number}
                                    </Typography>
                                  </Box>
                                ))}
                              {u.vehicles.filter(v => v.number?.trim()).length > 1 && (
                                <Typography variant="caption" color="text.secondary" sx={{ fontFamily: "'Poppins', sans-serif" }}>
                                  +{u.vehicles.filter(v => v.number?.trim()).length - 1} more
                                </Typography>
                              )}
                            </Box>
                          ) : (
                            <Typography color="text.secondary" sx={{ fontFamily: "'Poppins', sans-serif" }}>--</Typography>
                          )}
                        </TableCell>
                        
                        <TableCell>
                          <Typography variant="body2" sx={{ fontFamily: "'Poppins', sans-serif" }}>
                            {formatDate(u.scheduleDate || (u.vehicles && u.vehicles[0]?.scheduleDate))}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" sx={{ fontFamily: "'Poppins', sans-serif" }}>
                            {formatDate(u.endDate)}
                          </Typography>
                        </TableCell>
                        
                        <TableCell>
                          <Typography variant="body2" sx={{ fontFamily: "'Poppins', sans-serif", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                            {u.remarks || "--"}
                          </Typography>
                        </TableCell>
                        <TableCell>
<Chip label={getUserAggregateStatus(u)}
                            color={getUserAggregateColor(u)}
                            size="small"
                            sx={{ fontWeight: 600, minWidth: 100, fontFamily: "'Poppins', sans-serif" }}
                          />
                        </TableCell>
                        <TableCell>
                          {u.documents?.length > 0 ? (
                            <Tooltip title={`${u.documents.length} file(s)`}>
                              <Chip
                                icon={<DescriptionIcon sx={{ color: "white !important" }} fontSize="small" />}
                                label={`${u.documents.length} File(s)`}
                                variant="outlined"
                                sx={{
                                  fontFamily: "'Poppins', sans-serif",
                                  color: "white",
                                  borderColor: "rgba(255, 255, 255, 0.4)",
                                  backgroundColor: "rgba(255, 255, 255, 0.05)",
                                  "&:hover": {
                                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                                    borderColor: "white"
                                  },
                                  cursor: "pointer",
                                  "& .MuiChip-icon": { color: "white" }
                                }}
                                onClick={() => handleOpenFiles(u.documents)}
                              />
                            </Tooltip>
                          ) : (
                            <Chip
                              label="No Files"
                              size="small"
                              variant="outlined"
                              sx={{ fontFamily: "'Poppins', sans-serif", color: "rgba(255, 255, 255, 0.5)", borderColor: "rgba(255, 255, 255, 0.2)" }}
                            />
                          )}
                        </TableCell>
                        <TableCell>
                          <Box sx={{ display: "flex", gap: 1 }}>
                            <Tooltip title="View Details">
                              <IconButton
                                size="small"
                                onClick={() => handleViewDetails(u)}
                                sx={{ color: "#ffffff", opacity: 0.8, "&:hover": { opacity: 1, backgroundColor: "rgba(255, 255, 255, 0.1)" } }}
                              >
                                <Visibility fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Edit User">
                              <IconButton
                                size="small"
                                onClick={() => handleEditUser(u)}
                                sx={{ color: "#ffffff", opacity: 0.8, "&:hover": { opacity: 1, backgroundColor: "rgba(255, 255, 255, 0.1)" } }}
                              >
                                <EditIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            {/*enquiry table end*/}
 
            <Box sx={{ 
              display: "flex", 
              flexDirection: { xs: "column", sm: "row" }, 
              justifyContent: "space-between", 
              alignItems: "center", 
              mt: 3,
              gap: 2
            }}>
              <Typography variant="body2" color="text.secondary" sx={{ fontFamily: "'Poppins', sans-serif", textAlign: { xs: "center", sm: "left" } }}>
                Showing {displayedEnqUsers.length} of {filteredEnqUsers.length} users • Page {page + 1} of {Math.ceil(filteredEnqUsers.length / 5)}
              </Typography>
              <Pagination
                page={page + 1}
                count={Math.ceil(filteredEnqUsers.length / 5)}
                onChange={(e, v) => setPage(v - 1)}
                size="small"
                siblingCount={0}
                boundaryCount={1}
                sx={{
                  "& .MuiPaginationItem-root": { color: "#ffffff", borderColor: "rgba(255,255,255,0.2)" },
                  "& .Mui-selected": { bgcolor: "#FDB813 !important", color: "#111111", fontWeight: 800 }
                }}
                showFirstButton
                showLastButton
              />
            </Box>

          </CardContent>
        </Card>
      </Box>



      {/* Customer Details View Dialog */}
      <CustomerDetailsView
        open={viewDetailsDialog}
        onClose={() => setViewDetailsDialog(false)}
        user={selectedUser}
        getUserStatus={getUserStatus}
        handleEditUser={handleEditUser}
        handleFilePreview={handlePreview}
        loggedUserType={loggedUserType}
      />

      {/* File Preview Dialog */}
      <Dialog open={openFileDialog} onClose={handleCloseFiles} fullWidth maxWidth="sm">
        <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1, fontFamily: "'Poppins', sans-serif" }}>
          <DescriptionIcon color="primary" />
          Uploaded Documents
        </DialogTitle>

        <DialogContent>
          {selectedFiles.length === 0 ? (
            <Typography color="text.secondary" sx={{ textAlign: "center", py: 3, fontFamily: "'Poppins', sans-serif" }}>
              No files uploaded
            </Typography>
          ) : (
            <List>
              {selectedFiles.map((file, index) => (
                <ListItem
                  key={index}
                  sx={{
                    cursor: "pointer",
                    borderRadius: 1,
                    mb: 0.5,
                    fontFamily: "'Poppins', sans-serif",
                    "&:hover": { backgroundColor: "action.hover" }
                  }}
                  onClick={() => handlePreview(file)}
                >
                  <ListItemIcon>
                    <DescriptionIcon color="action" />
                  </ListItemIcon>
                  <ListItemText
                    primaryTypographyProps={{ fontFamily: "'Poppins', sans-serif" }}
                    secondaryTypographyProps={{ fontFamily: "'Poppins', sans-serif" }}
                    primary={file.name}
                    secondary={`Click to ${file.type?.startsWith("image") ? "preview" : "view"}`}
                  />
                </ListItem>
              ))}
            </List>
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCloseFiles} sx={{ fontFamily: "'Poppins', sans-serif" }}>Close</Button>
        </DialogActions>
      </Dialog>

      {
        /* ─── In-App File Viewer (3/4 Screen) ─── */
      }
      <Dialog
        open={Boolean(fileViewer)}
        onClose={handleCloseFileViewer}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            width: "90vw",
            height: "90vh",
            maxWidth: "90vw",
            maxHeight: "90vh",
            background: "#111111",
            border: "1px solid rgba(253,184,19,0.2)",
            borderRadius: 3,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden"
          },
        }}
      >
        {/* Header */}
        <DialogTitle
          sx={{
            width: "100%",
            background: "linear-gradient(135deg, #1a1a1a 0%, #111111 100%)",
            borderBottom: "1px solid rgba(253,184,19,0.2)",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            py: 1.5,
            px: 2.5,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, minWidth: 0 }}>
            <DescriptionIcon sx={{ color: "#FDB813", flexShrink: 0 }} />

            <Typography
              sx={{
                fontFamily: "'Poppins', sans-serif",
                fontWeight: 600,
                color: "#ffffff",
                fontSize: "1rem",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {fileViewer?.name || "File Preview"}
            </Typography>
          </Box>

          <IconButton
            onClick={handleCloseFileViewer}
            size="small"
            sx={{
              color: "rgba(255,255,255,0.6)",
              "&:hover": {
                color: "#ff4d4d",
                backgroundColor: "rgba(255,77,77,0.1)",
              },
            }}
          >
            ✕
          </IconButton>
        </DialogTitle>

        {/* Content */}
        <DialogContent
          sx={{
            flex: 1,
            p: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "auto",
            background: "#0a0a0a"
          }}
        >
          {fileViewer &&
            (() => {
              const isImage =
                fileViewer.type?.startsWith("image") ||
                /\.(png|jpe?g|gif|webp|svg|bmp)$/i.test(fileViewer.name || "");

              const isPdf =
                fileViewer.type === "application/pdf" ||
                /\.pdf$/i.test(fileViewer.name || "");

              /* IMAGE VIEWER */
              if (isImage) {
                return (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "100%",
                    }}
                  >
                    <img
                      src={fileViewer.url}
                      alt={fileViewer.name}
                      style={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        objectFit: "contain",
                        display: "block"
                      }}
                    />
                  </Box>
                );
              }

              /* PDF VIEWER */
              if (isPdf) {
                return (
                  <iframe
                    src={fileViewer.url}
                    title={fileViewer.name}
                    style={{
                      width: "100%",
                      height: "75vh",
                      border: "none",
                      borderRadius: "6px",
                    }}
                  />
                );
              }

              /* UNSUPPORTED FILE */
              return (
                <Box sx={{ textAlign: "center", p: 4 }}>
                  <DescriptionIcon sx={{ fontSize: 72, color: "#FDB813", mb: 2 }} />

                  <Typography
                    sx={{
                      fontFamily: "'Poppins', sans-serif",
                      color: "#ffffff",
                      mb: 1,
                      fontWeight: 600,
                    }}
                  >
                    {fileViewer.name}
                  </Typography>

                  <Typography
                    sx={{
                      fontFamily: "'Poppins', sans-serif",
                      color: "rgba(255,255,255,0.5)",
                      mb: 3,
                    }}
                  >
                    Preview not available for this file type. Click Download to open
                    it.
                  </Typography>
                </Box>
              );
            })()}
        </DialogContent>

        {/* Footer */}
        <DialogActions
          sx={{
            width: "100%",
            background: "linear-gradient(135deg, #1a1a1a 0%, #111111 100%)",
            borderTop: "1px solid rgba(253,184,19,0.2)",
            px: 2.5,
            py: 1.5,
            justifyContent: "flex-end",
            gap: 1,
          }}
        >
          <Button
            onClick={handleCloseFileViewer}
            variant="outlined"
            sx={{
              fontFamily: "'Poppins', sans-serif",
              color: "rgba(255,255,255,0.7)",
              borderColor: "rgba(255,255,255,0.3)",
              "&:hover": {
                borderColor: "#ffffff",
                color: "#ffffff",
                backgroundColor: "rgba(255,255,255,0.05)",
              },
            }}
          >
            Close
          </Button>

          <Button
            onClick={handleDownloadFile}
            variant="contained"
            sx={{
              fontFamily: "'Poppins', sans-serif",
              background: "linear-gradient(135deg, #FDB813 0%, #f5a623 100%)",
              color: "#111111",
              fontWeight: 700,
              "&:hover": {
                background: "linear-gradient(135deg, #f5a623 0%, #e09400 100%)",
                boxShadow: "0 4px 16px rgba(253,184,19,0.4)",
              },
            }}
          >
            <i class="bi bi-cloud-arrow-down-fill"></i>&nbsp;Download
          </Button>
        </DialogActions>
      </Dialog>


      {/* Delete Confirmation Dialog */}
      <Dialog open={openDeleteDialog} onClose={handleCloseDelete}>
        <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1, fontFamily: "'Poppins', sans-serif" }}>
          <WarningAmber color="error" /> Confirm Delete
        </DialogTitle>
        <DialogContent>
          <Typography sx={{ fontFamily: "'Poppins', sans-serif" }}>
            Are you sure you want to delete this user? This action cannot be undone.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDelete} sx={{ fontFamily: "'Poppins', sans-serif" }}>Cancel</Button>
          <Button
            color="error"
            variant="contained"
            onClick={() => {
              handleDeleteUser(deleteUserId);
              handleCloseDelete();
            }}
            sx={{ fontFamily: "'Poppins', sans-serif" }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar for copy notification */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          severity={snackbar.severity}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          sx={{ fontFamily: "'Poppins', sans-serif" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box >
  );
}